<template>
  <div v-if="isShow" class="setmealFoodTable">
    <div>套餐菜品</div>
    <a-table size="small" :pagination="false" rowKey="Id" :data-source="data">
      <a-table-column key="Name" title="名称" data-index="Name">
      </a-table-column>
      <a-table-column
        key="Quantity"
        title="数量"
        data-index="Quantity"
        width="130px"
        align="center"
      >
        <template slot-scope="text, record">
          <a-input-number v-model="record.Quantity" />
        </template>
      </a-table-column>
      <a-table-column
        key="Id"
        title="操作"
        data-index="Id"
        width="100px"
        align="center"
      >
        <template slot-scope="text">
          <a @click="removeRow(text)">移除</a>
        </template>
      </a-table-column>
    </a-table>
    <a-button @click="showAddFoodModal">+ 添加菜品</a-button>
  </div>
</template>

<script>
import selectFoodModal from "./selectFoodModal";
import cloneDeep from "lodash/cloneDeep";

export default {
  data() {
    return {
      isShow: false,
      data: []
    };
  },
  methods: {
    show() {
      this.isShow = true;
    },
    hide() {
      this.isShow = false;
    },
    showAddFoodModal() {
      const { data } = this;
      const that = this;
      // const ids = that.data.map(p => p.Id);
      selectFoodModal({
        title: "选择套餐菜品",
        defaultValue: that.data,
        submit: list => {
          // that.data = values;
          // 合并数量
          const newData = cloneDeep(list).map(item => {
            const find = data.find(p => p.Id === item.Id);
            if (find) {
              item.Quantity = find.Quantity ? find.Quantity : 1;
            } else {
              item.Quantity = 1;
            }
            return item;
          });
          that.data = newData;
        }
      });
    },
    getData() {
      return this.data;
    },
    setData(data) {
      this.data = cloneDeep(data);
    },
    removeRow(id) {
      this.data = this.data.filter(p => p.Id != id);
    }
    // onRowQuantityChange(record, val) {
    //   record.Quantity = val;
    //   const find = this.data.find(p => p.Id === record.Id);
    //   find.Quantity = val;
    // }
  }
};
</script>
